import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { getData } from "src/utils/axios/serverHelper";
import { formatDate } from "src/utils/string/stringUtil";

import { WMS1060_R01Dto, WMS1060_R01Filter } from "./Dto_WMS1060_R01";

const baseUrl = `${config.apiUrl}/WMS1060_R01`;

/**
 * 검색 파라미터 변환
 * 
 * @param filter 검색 조건
 * @param listLength 조회 건수 (0 = 전체)
 * @returns API 요청 파라미터
 */
const getParams = (filter: Partial<WMS1060_R01Filter>, listLength?: number) => {
    return {
        startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
        endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
        searchLogicCenter: filter.logicCenter || undefined,
        searchWarehouseCd: filter.warehouseCd || undefined,
        searchInoutType: filter.inoutType || undefined,
        searchInoutClass: filter.inoutClass || undefined,
        searchItemGroup: filter.itemGroup || undefined,
        searchCustomCd: filter.customCd || undefined,
        searchItemCd: filter.itemCd || undefined,
        listLength: listLength || 0
    };
};

/**
 * 출하현황 목록 조회
 * 
 * @param option 'search' | 'refetch'
 * @param params 검색 조건
 * @param listLength 조회 건수
 * @returns 출하 내역 목록
 */
export const getWMS1060_R01List = async (
    option: string, 
    params: Partial<WMS1060_R01Filter>, 
    listLength: number = 0
) => {
    const url = `${baseUrl}/${option}`;
    
    return await getData<ResponseDto<WMS1060_R01Dto[]>>(url, {
        params: getParams(params, listLength)
    });
};

/**
 * 출하현황 전체 건수 조회
 * 
 * @param params 검색 조건
 * @returns 전체 건수
 */
export const getWMS1060_R01AllCount = async (params: Partial<WMS1060_R01Filter>) => {
    const url = `${baseUrl}/allCount`;
    
    return await getData<ResponseDto<number>>(url, {
        params: getParams(params, 0)
    });
};

/**
 * 출하현황 엑셀 다운로드
 * 
 * @param option 'search'
 * @param params 검색 조건
 * @returns 엑셀 파일 (Base64 string)
 */
export const downloadExcel_WMS1060_R01 = async (
    option: string, 
    params: Partial<WMS1060_R01Filter>
) => {
    const url = `${baseUrl}/excel/${option}`;
    
    return await getData<ResponseDto<string>>(url, {
        params: getParams(params, 0)
    });
};
